
import { Component, Vue } from 'vue-property-decorator'
import Teleport from '@xt/client/mixins/components/teleport.vue'

@Component({
  inheritAttrs: false,
  components: {
    Teleport
  }
})
export default class extends Vue {
  show = false

  // 点击背景关闭确认弹窗
  clickToClose = true

  onOk(params) {
    params.onOk && params.onOk()
    this.show = false
  }

  onCancel() {
    this.show = false
  }

  handleBeforeOpen(event) {
    const params = event.ref.params

    if (params.clickToClose === false) {
      this.clickToClose = false
    } else {
      this.clickToClose = true
    }
  }
}
